import {Capacitor} from '@capacitor/core';

export const BILLING_CHANNEL = Object.freeze({
  PLAY_READ_ONLY: 'play-read-only',
  IOS_READ_ONLY: 'ios-read-only',
  IOS_APP_STORE: 'ios-app-store',
  STRIPE: 'stripe'
});

export function getBillingChannel(platform = Capacitor.getPlatform(), appleIapEnabled = false) {
  if (platform === 'web') return BILLING_CHANNEL.STRIPE;
  if (platform === 'android') return BILLING_CHANNEL.PLAY_READ_ONLY;
  if (platform === 'ios' && appleIapEnabled === true) return BILLING_CHANNEL.IOS_APP_STORE;
  return BILLING_CHANNEL.IOS_READ_ONLY;
}

export function allowsStripeBilling(platform = Capacitor.getPlatform()) {
  return getBillingChannel(platform) === BILLING_CHANNEL.STRIPE;
}

export function isIosConsumptionOnly(platform = Capacitor.getPlatform(), appleIapEnabled = false) {
  return getBillingChannel(platform, appleIapEnabled) === BILLING_CHANNEL.IOS_READ_ONLY;
}

export function allowsAppleBilling(platform = Capacitor.getPlatform(), appleIapEnabled = false) {
  return getBillingChannel(platform, appleIapEnabled) === BILLING_CHANNEL.IOS_APP_STORE;
}
